import { isDebugFlagEnabled } from './motionDebug';

export const isLocalhost = () =>
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const isDebugLoggingEnabled = () =>
  isLocalhost() && isDebugFlagEnabled('debug', 'debugMotion', 'debugSlides', 'debugCarousel', 'debugLayout', 'debugSafari');

export const debugLog = (...args) => {
  if (isDebugLoggingEnabled()) console.log(...args);
};

export const debugWarn = (...args) => {
  if (isDebugLoggingEnabled()) console.warn(...args);
};
